export default __webpack_public_path__ + "static/media/croissant.3760b3fa.jpg";